import { render, staticRenderFns } from "./shareKnowledge.vue?vue&type=template&id=87802bac&scoped=true"
import script from "./shareKnowledge.vue?vue&type=script&lang=js"
export * from "./shareKnowledge.vue?vue&type=script&lang=js"
import style0 from "./shareKnowledge.vue?vue&type=style&index=0&id=87802bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87802bac",
  null
  
)

export default component.exports